import { compact, keyBy, get, omit } from 'lodash'

import {
  FETCH_PRINTERS,
  DELETE_PRINTER,
  UPDATE_PRINTER,
  CREATE_PRINTER,
  SET_PRINTERS_FILTER,
} from './actionTypes'

const initialState = { byId: {}, filters: {} }

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_PRINTERS: {
      const devices = compact(payload.printers)

      return {
        ...state,
        byId: keyBy(devices, 'uuid'),
      }
    }

    case DELETE_PRINTER: {
      const deletedDeviceId = get(payload, ['printers', 0, 'uuid'])

      return {
        ...state,
        byId: omit(state.byId, deletedDeviceId),
      }
    }

    case UPDATE_PRINTER: {
      const updatedPrinter = get(payload, ['printers', 0], {})
      const updatedById = updatedPrinter.uuid
        ? { ...state.byId, [updatedPrinter.uuid]: updatedPrinter }
        : { ...state.byId }

      return {
        ...state,
        byId: updatedById,
      }
    }

    case CREATE_PRINTER: {
      const createdPrinter = get(payload, ['printers', 0], {})
      const updatedById = createdPrinter.uuid
        ? { ...state.byId, [createdPrinter.uuid]: createdPrinter }
        : { ...state.byId }

      return {
        ...state,
        byId: updatedById,
      }
    }

    case SET_PRINTERS_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.name]: payload.value,
        },
      }
    }

    default:
      return state
  }
}
